module.exports = __webpack_public_path__ + "img/bulletinDefaultImage.bb92d91b.png";